let sessionTag;

export function getSessionTag() {
  if (!sessionTag) {
    sessionTag = Math.random().toString(36).substr(2, 10);
  }
  return sessionTag;
}

